// extracted by css-extract-rspack-plugin
var _1 = "ai-extractor-assignment-EB8Q4J";
var _2 = "ai-extractor-assignment-list-Rc282O";
var _3 = "ai-extractor-assignment-organization-yzGRAb";
var _4 = "ai-extractor-assignment-tag-GFxM0V";
var _5 = "ai-extractor-assignment-EB8Q4J";
var _6 = "ai-extractor-assignment-list-Rc282O";
var _7 = "ai-extractor-assignment-organization-yzGRAb";
var _8 = "ai-extractor-assignment-tag-GFxM0V";
var _9 = "details-F2BzkF";
var _a = "details-column-a6fAWB";
var _b = "details-column-a6fAWB";
var _c = "table-f7m2xl";
var _d = "view-description-fMLg8q";
var _e = "view-description-fMLg8q";
export { _1 as "ai-extractor-assignment", _2 as "ai-extractor-assignment-list", _3 as "ai-extractor-assignment-organization", _4 as "ai-extractor-assignment-tag", _5 as "aiExtractorAssignment", _6 as "aiExtractorAssignmentList", _7 as "aiExtractorAssignmentOrganization", _8 as "aiExtractorAssignmentTag", _9 as "details", _a as "details-column", _b as "detailsColumn", _c as "table", _d as "view-description", _e as "viewDescription" }
